module.exports = __webpack_public_path__ + "static/cloud-data-bb5b4e7c26d11025c422a177082c0d15.jpg";